import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../../../utils/withRouter';
import Loader from '../../../../utils/Loader'
// import { clearSessionStorage } from '../../../utils/constants'
import Header from '../../../../common_components/Header';
// import { emailValidator } from '../../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from '../../../../common_components/Footerwithdr';
import HeaderWithLogo from '../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../common_components/admin_module_drawer';
import { fill_action } from '../../../../actions/fillCombo_action'
// import ReceiptList from '../registration_receipt/ReceiptList';
import { Link } from "react-router-dom";
import { getAdminDashboardData_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action"
import { data } from 'jquery';
import { getAdminPaymentSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action"
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip"
class PaymentSummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            paymentSummaryList: [],
        }
        this.record = this.record.bind(this)
        this.getPaymentSummaryList = this.getPaymentSummaryList.bind(this)
        this.onCountClick = this.onCountClick.bind(this)

    }

    componentDidMount() {
        this.getPaymentSummaryList()
    }

    // Get suummary list
    getPaymentSummaryList() {
        this.setState({ isLoading: true })
        this.props.getAdminPaymentSummaryList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Admin Data ------->", data.data)
                    // data.data.length > 0 && data.data.map((dat) => (
                    //     dat.Total = dat.Applied + dat.Agent + dat.Waiting + dat.Incomplete
                    // ))
                    // data.data.sort((a, b) =>
                    //     a.ChapterName.toLowerCase().localeCompare(b.ChapterName.toLowerCase())
                    // );
                    var temptotalSalable = 0
                    var temptotalAppliedExhCount = 0
                    var temptotalAppliedArea = 0
                    var temptotal0perPaidExhCount = 0
                    var temptotal0perPaidArea = 0
                    var temptotal1stInstPartialPaidExhCount = 0
                    var temptotal1stInstPartialPaidArea = 0
                    var temptotalOnly1stInstFullPaidExhCount = 0
                    var temptotalOnly1stInstFullPaidArea = 0
                    var temptotalFullPaidExhCount = 0
                    var temptotalFullPaidArea = 0
                    var temptotalExcessPaidExhCount = 0

                    var obj = {}

                    for (var i = 0; i < data.data.length; i++) {
                        temptotalSalable = temptotalSalable + data.data[i].SalebleArea
                        temptotalAppliedExhCount = temptotalAppliedExhCount + data.data[i].AppliedExibitorCount
                        temptotalAppliedArea = temptotalAppliedArea + data.data[i].AppliedArea
                        temptotal0perPaidExhCount = temptotal0perPaidExhCount + data.data[i].ZeroPercentPaidCount
                        temptotal0perPaidArea = temptotal0perPaidArea + data.data[i].ZeroPercentPaid
                        temptotal1stInstPartialPaidExhCount = temptotal1stInstPartialPaidExhCount + data.data[i].FirstInstPartialPaidCount
                        temptotal1stInstPartialPaidArea = temptotal1stInstPartialPaidArea + data.data[i].FirstInstPartialPaidArea
                        temptotalOnly1stInstFullPaidExhCount = temptotalOnly1stInstFullPaidExhCount + data.data[i].FirstInstFullPaidCount
                        temptotalOnly1stInstFullPaidArea = temptotalOnly1stInstFullPaidArea + data.data[i].FirstInstFullPaidArea
                        temptotalFullPaidExhCount = temptotalFullPaidExhCount + data.data[i].HundredPercentPaidCount
                        temptotalFullPaidArea = temptotalFullPaidArea + data.data[i].HundredpercentFullPaidArea
                        temptotalExcessPaidExhCount = temptotalExcessPaidExhCount + data.data[i].ExcessPaidCount
                    }

                    obj.SalebleArea = temptotalSalable
                    obj.AppliedExibitorCount = temptotalAppliedExhCount
                    obj.AppliedArea = temptotalAppliedArea
                    obj.ZeroPercentPaidCount = temptotal0perPaidExhCount
                    obj.ZeroPercentPaid = temptotal0perPaidArea
                    obj.FirstInstPartialPaidCount = temptotal1stInstPartialPaidExhCount
                    obj.FirstInstPartialPaidArea = temptotal1stInstPartialPaidArea
                    obj.FirstInstFullPaidCount = temptotalOnly1stInstFullPaidExhCount
                    obj.FirstInstFullPaidArea = temptotalOnly1stInstFullPaidArea
                    obj.HundredPercentPaidCount = temptotalFullPaidExhCount
                    obj.HundredpercentFullPaidArea = temptotalFullPaidArea
                    obj.ExcessPaidCount = temptotalExcessPaidExhCount
                    obj.ChapterName = 'TOTAL'
                    if (data.data.length > 0 && data.data[data.data.length - 1].ChapterName != 'TOTAL') {
                        data.data.push(obj)
                    }
                    this.setState({
                        isLoading: false,
                        paymentSummaryList: data.data,
                        // pendingPaymentCount: data.data[0]['Count_Of_Payment']
                    })
                    console.log("Data ------->", this.state.paymentSummaryList)

                } else {
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onCountClick(chapterName, status) {
        console.log("Keyword------------>", `${chapterName.trim()}/${status}`)
        this.props.navigate('/exhibitorlist', {
            state: {
                fromDashBoard: true,
                paymentType: status == "EXHIBITORS_25%" ? 2 : status == "EXHIBITORS_100%" ? 3 : null,
                exhibitorType: chapterName.trim() == "INDIAN PARTICIPANTS" ? 1 : chapterName.trim() == "FOREIGN PARTICIPANTS" ? 2 :
                    chapterName.trim() == "TOTAL" ? "" : null
            }
        })
    }

    record(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center">Primary Segment</th>
                        <th className="text-center">Salable Area(sqm)</th>
                        <th className="text-center" colspan="2">Applied</th>
                        <th className="text-center" colspan="2">0% Paid</th>
                        <th className="text-center" colspan="2">1st Installment Partial Paid</th>
                        <th className="text-center" colspan="2">Only 1st Installment Full Paid</th>
                        <th className="text-center" colspan="2">100% Paid</th>
                        <th className="text-center">Excess Paid</th>
                    </tr>
                    <tr>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center"> Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"> Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"> Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"> Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"> Count</th>
                        <th className="text-center">Area(sqm)</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    <td className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.ChapterName}</strong>
                                        ) : (
                                            <>
                                                {data.ChapterName}

                                                {data.HallNames && (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id={`tooltip-${i}`}>
                                                                {data.HallNames}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i
                                                            className="bi bi-info-circle ms-1"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </OverlayTrigger>
                                                )}
                                            </>
                                        )}
                                    </td>
                                    <td className={data.SalebleArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "SalebleArea")}
                                    >{i == list.length - 1 ? <strong>{data.SalebleArea}</strong> : data.SalebleArea}</td>
                                    <td className={data.AppliedExibitorCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedExibitorCount}</strong> : data.AppliedExibitorCount}</td>
                                    <td className={data.AppliedArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                                    >{i == list.length - 1 ? <strong>{data.AppliedArea}</strong> : data.AppliedArea}</td>
                                    <td className={data.ZeroPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "ZeroPercentPaidCount")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaidCount}</strong> : data.ZeroPercentPaidCount}</td>
                                    <td className={data.ZeroPercentPaid < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "ZeroPercentPaid")}
                                    >{i == list.length - 1 ? <strong>{data.ZeroPercentPaid}</strong> : data.ZeroPercentPaid}</td>
                                    <td className={data.FirstInstPartialPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "FirstInstPartialPaidCount")}
                                    >{i == list.length - 1 ? <strong>{data.FirstInstPartialPaidCount}</strong> : data.FirstInstPartialPaidCount}</td>
                                    <td className={data.FirstInstPartialPaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "FirstInstPartialPaidArea")}
                                    >{i == list.length - 1 ? <strong>{data.FirstInstPartialPaidArea}</strong> : data.FirstInstPartialPaidArea}</td>
                                    <td className={data.FirstInstFullPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "FirstInstFullPaidCount")}
                                    >{i == list.length - 1 ? <strong>{data.FirstInstFullPaidCount}</strong> : data.FirstInstFullPaidCount}</td>
                                    <td className={data.FirstInstFullPaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "FirstInstFullPaidArea")}
                                    >{i == list.length - 1 ? <strong>{data.FirstInstFullPaidArea}</strong> : data.FirstInstFullPaidArea}</td>
                                    <td className={data.HundredPercentPaidCount < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "HundredPercentPaidCount")}
                                    >{i == list.length - 1 ? <strong>{data.HundredPercentPaidCount}</strong> : data.HundredPercentPaidCount}</td>
                                    <td className={data.HundredpercentFullPaidArea < 0 ? "text-center text-danger" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "HundredpercentFullPaidArea")}
                                    >{i == list.length - 1 ? <strong>{data.HundredpercentFullPaidArea}</strong> : data.HundredpercentFullPaidArea}</td>
                                    <td className={data.ExcessPaidCount > 0 ? "text-center text-success" : "text-center"} style={{ cursor: "pointer" }}
                                        // onClick={(e) => this.onCountClick(data.ChapterName, "ExcessPaidCount")}
                                    >{i == list.length - 1 ? <strong>{data.ExcessPaidCount}</strong> : data.ExcessPaidCount}</td>
                                </tr>
                            ))}
                            {/* {list[list.length - 1].Details != 'TOTAL' &&
                                <tr key={Math.random()}>
                                    <td className="text-center"><strong>TOTAL</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea25}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalExhibitor100}</strong></td>
                                    <td className="text-center"><strong>{this.state.totalArea100}</strong></td>

                                </tr>} */}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    render() {
        const { isLoading, paymentSummaryList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />
                    {/*app-content open*/}
                    {/* <div className="app-content with-dr-container com-height"> */}
                    {/* <AdminDashboardTopmenu /> */}
                    <div className='admin-top-space'>
                        <div className="row mt-2 m-0">
                            <div className="table-responsive mb-3 mt-2">
                                {this.record(paymentSummaryList)}
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                </>
                {/* <Footerwithdr /> */}
            </>
        );
    }
}

export default withRouter(connect(null, { getAdminPaymentSummaryList_action, getAdminDashboardData_action })(PaymentSummary));
